import React from 'react';
import { Under13TeamManager } from '@/components/teams/Under13TeamManager';
import { TeamAccessCodeGenerator } from '@/components/teams/TeamAccessCodeGenerator';
import { useTeamAccessCode } from '@/hooks/useTeamAccessCode';

interface TeamPageProps {
  teamId: number;
  teamName: string;
  teamAgeGroup?: string;
}

export const TeamCodeManagement: React.FC<TeamPageProps> = ({ 
  teamId, 
  teamName, 
  teamAgeGroup 
}) => {
  // Check if this is a 13 and under team
  const isUnder13Team = teamAgeGroup && (
    ['1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '13-and-under', '13 and under'].includes(teamAgeGroup) ||
    teamAgeGroup.toLowerCase().includes('13') && teamAgeGroup.toLowerCase().includes('under')
  );

  if (!isUnder13Team) {
    return null; // Don't show anything for over 13 teams
  }

  return (
    <div className="space-y-6">
      <Under13TeamManager 
        teamId={teamId} 
        teamName={teamName} 
        teamAgeGroup={teamAgeGroup} 
      />
    </div>
  );
};